import { Component, effect, inject, signal } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { TotpAuthStore } from './totp-auth.store';
import { TOTP_DIGIT_COUNT, TotpCodeComponent } from './totp-code.component';
import { TotpEnrollDialogComponent } from './totp-enroll-dialog.component';

type TotpResetStep = 'code' | 'confirm';

@Component({
  imports: [MatDialogModule, MatProgressSpinner, TotpCodeComponent],
  selector: 'avs-totp-reset-dialog',
  templateUrl: './totp-reset-dialog.component.html',
})
export class TotpResetDialogComponent {
  protected isCodeComplete = signal(false);
  protected step = signal<TotpResetStep>('code');
  protected store = inject(TotpAuthStore);
  protected token = signal('');

  private dialog = inject(MatDialog);

  constructor() {
    this.store.reset();

    effect(() => {
      if (this.store.currentCodeVerified()) {
        this.step.set('confirm');
      }
    });
  }

  protected onTokenChange(value: string) {
    this.token.set(value);
    this.isCodeComplete.set(value.length === TOTP_DIGIT_COUNT);

    if (this.store.error()) {
      this.store.clearError();
    }
  }

  protected startReplacement() {
    this.dialog.closeAll();
    this.dialog.open(TotpEnrollDialogComponent, {
      backdropClass: 'backdrop-modal-panel',
      disableClose: true,
    });
  }

  protected verify() {
    if (this.isCodeComplete()) {
      this.store.verifyCurrent(this.token());
    }
  }
}
